import Questionnaire from "../sections/Questionnaire";

const icons = [
  {
    title: "in Freiluft",
    externalLink: "/hauswasserautomat",
    imgUrl: "/content/uploads/2018/08/baum.png"
  },
  {
    title: "in der Zisterne",
    externalLink: "/?s=zisternenpumpe&post_type=product",
    imgUrl: "/content/uploads/2018/08/brunnen-1.png"
  }
]

export function Regenwasser() {

  return (
    <Questionnaire question={"Wo wird die Pumpe platziert?"} icons={icons} />
  );
}